import {observable, computed, action} from 'mobx';

export default class HallStore {

    @observable foodCourtName = 'Food Court';
    @observable shopsPerPage = 6;
    @observable paginationRate = 7000;
    @observable currSubList = 0;
    @observable shopsList = [];
    @observable shopItemHeight = null;

    @action setHallData(hallData) {
        if(!hallData) {
            return;
        }
        this.setFoodCourtName(hallData.hall_name);
        this.updateHallShopsList(hallData.shops_info);
    }


    @action paginateShopListData() {
        if(!isNaN(this.currSubList) && !isNaN(this.shopListPageCount)) {
            this.currSubList = (this.currSubList + 1) % this.shopListPageCount;
        } else {
            this.currSubList = 0;
        }
    }


    @action setFoodCourtName(name){
        if(typeof name !== 'undefined') {
            this.foodCourtName = name;
        }
    }


    @action updateHallShopsList(shops) {
        this.shopsList = shops;
    }


    @computed get shopListPageCount() {
        return Math.ceil(this.shopsList.length / this.shopsPerPage);
    }


    @computed get wideShopListHallPage(){
        if(this.shopsList.length > 6) {
            return true;
        } else {
            return false;
        }
    }


    @computed get shopListLength() {
        return this.shopsList.length;
    }


    @computed get hallPanelShopListFooter(){
        if(this.shopListPageCount <= 1) {
            return ''
        }
        else {
            return `${this.currSubList + 1}/${this.shopListPageCount}`;
        }
    }


    @computed get currentSubListStartingIndex(){
        return this.currSubList*this.shopsPerPage;
    }


    @computed get currentSubListEndingIndex(){
        return Math.min(this.currentSubListStartingIndex + this.shopsPerPage, this.shopsList.length);
    }

    @action setShopItemHeight(newShopItemHeight) {
        this.shopItemHeight = newShopItemHeight;
    }

}



// WEBPACK FOOTER //
// ./src/stores/HallStore.js